module.exports = __webpack_public_path__ + "e38f9214f38cb9a150db5e6ecc4c673a.fbx";